export default {
  startDate: null,
  endDate: null,
  selectedButton: null,
  selectedValue: null,
};
